import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getCaseNoConsents(params: any): AxiosPromise {
    return EndPointService.get('/occasions/without-consent', { params });
}

function getCaseNoConsent(id: number | string): AxiosPromise {
    return EndPointService.get(`/caseNoConsents/${id}`);
}

function deleteCaseNoConsent(id: number | string): AxiosPromise {
    return EndPointService.delete(`/caseNoConsents/${id}`);
}

function createCaseNoConsent(payload: any): AxiosPromise {
    return EndPointService.post('/caseNoConsents', payload);
}

function updateCaseNoConsent(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/caseNoConsents/${id}`, { ...payload });
}

export default {
    getCaseNoConsents,
    getCaseNoConsent,
    deleteCaseNoConsent,
    createCaseNoConsent,
    updateCaseNoConsent,
};
